import { createContext, ReactNode, useMemo, useState } from "react";

interface SidebarProviderProps {
	children: ReactNode;
}

interface SidebarContextData {
	isOpenDrawer: boolean;
	handleToggleMenu: () => void;
	isNavigateBlocked: boolean;
	handleIsNavigateBlocked: (isNavigateBlocked: boolean) => void;
	linkNavigateBlocked: string;
	handleLinkNavigateBlocked: (linkBlocked: string) => void;
}

export const SidebarContext = createContext({} as SidebarContextData);

export const SidebarProvider = ({ children }: SidebarProviderProps) => {
	const [isOpenDrawer, setIsOpenDrawer] = useState(true);
	const [isNavigateBlocked, setIsNavigateBlocked] = useState(false);
	const [linkNavigateBlocked, setLinkNavigateBlocked] = useState("");

	const handleToggleMenu = () => {
		setIsOpenDrawer((old) => !old);
	};

	const handleIsNavigateBlocked = (isNavigateBlocked: boolean) => {
		setIsNavigateBlocked(isNavigateBlocked);
	};

	const handleLinkNavigateBlocked = (linkBlocked: string) => {
		setLinkNavigateBlocked(linkBlocked);
	};

	const valuesContext = useMemo(() => {
		return {
			isOpenDrawer,
			handleToggleMenu,
			isNavigateBlocked,
			handleIsNavigateBlocked,
			linkNavigateBlocked,
			handleLinkNavigateBlocked,
		};
	}, [isOpenDrawer, isNavigateBlocked, linkNavigateBlocked]);

	return (
		<SidebarContext.Provider value={valuesContext}>
			{children}
		</SidebarContext.Provider>
	);
};
